@for (toast of toastService.toasts; track toast) {
  <ngb-toast
    [class]="toast.className"
    [autohide]="true"
    [delay]="toast.delay || 5000"
    [header]="toast.header ?? ''"
    (hidden)="toastService.remove(toast)">
    <span>{{ toast.message }}</span>
  </ngb-toast>
}
